import React from 'react'
import { IconProps } from '../../../common/types'

const Hamburger: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66406 4H13.3307M2.66406 8H13.3307M2.66406 12H13.3307"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Hamburger
